import moment from "moment";
import { CountUpTimer } from "react-countup-timer";


import React from 'react'
import { useSelector } from "react-redux";

const Timer = ({ date }) => {
    const { downTimeDate } = useSelector(state => state.logs)
    return (
        <CountUpTimer startTime={date ? moment(date).unix() : moment(`${moment(downTimeDate).format('YYYY-MM-DD')}T02:00:00.000Z`).unix()} />
    )
}

export default Timer
